function shuffle(array) {
  const result = array.slice();
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

function revealRandomReviews(grid) {
  const pool = grid.querySelector('[data-reviews-pool]');
  if (!pool) return;

  const count = parseInt(grid.getAttribute('data-review-show-count'), 10) || 3;
  const cards = Array.from(pool.querySelectorAll('[data-review-card]'));

  shuffle(cards)
    .slice(0, count)
    .forEach((card) => card.classList.add('review-card--visible'));
}

document.querySelectorAll('[data-reviews-grid]').forEach(revealRandomReviews);
